import { useEffect, useState } from "react";
import useDataBean from "../../../../../../../core/services/dataBean/useDataBean";
import { _BudgetRPFactory, _RemoteAbstractAction, _single } from "../../../../../../../core/services/dataBean/EntityCatalog";
import { BasicTable, MASK_MONEY } from "../../../../../../theme/Component/BasicTable";
import { ListMenu } from "../../../../../../theme/Component/ListMenu";
import { Modal } from "../../../../../../theme/Component/Modal";
import { InputMoney } from "../../../../../../theme/Input/InputMoney";
import { BasicButton } from "../../../../../../theme/Component/BasicButton";
import { PrintJson } from "../../../../../../theme/Component/PrintJson";
import { SelectProductEditor } from "../../../../../../Factoty&Production/ManufacturingStandars/Components/SelectProductEditor";
import { _CreateProductRowvDOS } from "../../../../../../../core/services/dataBean/EntityCatalogVdos";
import { BasicSwitch } from "../../../../../../theme/Component/BasicSwitch";
import { ProductTaxsCatalogForAddedValue } from "../../../../../../Inventories-Warehouses/Product/ProductTaxes/ProductTaxsCatalogForAddedValue";
import { ProductionOrderEditor } from "../../../../../../Factoty&Production/ProductionOrder/ProductionOrderEditor";
import { SelectRawMaterialByProductionOrder } from "./SelectRawMaterialByProductionOrder";
import { toast } from "react-toastify";
import { SelectRecurso } from "../../../../../../Factoty&Production/LabourType/SelectRecurso";
import { SelectInputRawMaterialByProductionOrder } from "./SelectInputRawMaterialByProductionOrder";
import { ModalConfirm } from "../../../../../../theme/Component/ModalConfirm";

import { CatalogByRawMaterialRequestEditor } from "../../../../../../Factoty&Production/ProductionOrderProcees/ProductionOrderCatalogForRawMaterial/getRawMaterialCatalogByRawMaterialRequest/CatalogByRawMaterialRequestEditor";
import { CatalogForRawMaterialeditor } from "../../../../../../Factoty&Production/ProductionOrderProcees/ProductionOrderCatalogForRawMaterial/ProductionOrderCatalogForRawMaterialEditor/CatalogForRawMaterialeditor";


interface Props {
    idApplicationInvoker: number,
    properties: any;
    data: any;
    setData: any;
    lastStep: boolean;
}
export const InventoryRawMaterialTranslateFactory = ({ idApplicationInvoker, properties, lastStep, data, setData }: Props) => {
    const { instance, update, handleChange, deleteItemVoid } = useDataBean(_CreateProductRowvDOS);
    const [bean, setBean] = useState<any>({});
    const [lista, setLista] = useState<any>([]);
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [showFile, setShowFile] = useState<any>(null)
    // const { lista, setLista, bean, setBean } = useDataBean(_RemoteAbstractAction);
    const [addtable, setAddtable] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalbysolicitud, setModalbysolicitud] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [prevBean, setPrevBean] = useState<any>(null);



    useEffect(() => {
        if (properties.ProductList)
            setLista(properties.ProductList);
    }, [properties])



    const head = [
        { title: 'ID', property: 'IDProduct', visible: true },
        { title: 'Producto', property: 'Description', visible: true },
        { title: 'Código Medida', property: 'MeasurementUnitCode', visible: true },
        { title: 'Unidad Medida', property: 'MeasurementUnitName', visible: true },
        { title: 'Valor Unitario', property: 'ProductCost', visible: true },
        // { title: 'Cantidad en Inventario', property: 'TotalQuantity', visible: true },
        { title: 'Cantidad', property: 'Quantity', visible: true },
        { title: 'Cantidad en Inventario', property: 'TotalQuantity', visible: true },
        { title: 'Orden de Producción', property: 'ProductionOrderName', visible: true },
        { title: 'Observaciones', property: 'Description', visible: true },


    ]




    const create = () => {
        setBean({
            IDEmployee: _single.getAccountID()
        });
        setModal({ ...modal, "view": true, "name": "Agregar" });
    }

    const createvdos = () => {
        setBean({

        });
        setModalbysolicitud({ ...modalbysolicitud, "view": true, "name": "Agregar" });
    }

    const iconButtonsItem = [
        { nombre: 'Agregar Orden de Producción', visible: true, icono: 'ri-file-add-line', evento: create },
        { nombre: 'Agregar Solicitud de Materia Prima', visible: true, icono: 'ri-file-add-line', evento: createvdos }
    ]

    const createProductRow = () => {
        // Validar si ambos están definidos — esto puede representar un error
        if (bean.IDRawMaterial && bean.IDProductRef) {
            toast.warning("Solo debe seleccionar un valor: Materia Prima o Producto.");
            return;
        }

        // Validar si ninguno está definido
        if (!bean.IDRawMaterial && !bean.IDProductRef) {
            toast.warning("Debe seleccionar al menos Materia Prima o Producto.");
            return;
        }

        const idRawMaterial = bean.IDRawMaterial || null;
        const idProductRef = bean.IDRawMaterial ? null : bean.IDProductRef;

        instance.createProductRowForRawMaterial(
            bean.IDProductionOrder,
            bean.ProductionOrderDate,
            idRawMaterial,
            idProductRef,
            properties.IDStore,
            bean.Quantity
        ).then((rta: any) => {
            let x = [...lista];
            x.push({ DataBeanProperties: rta, DataBeanName: 'inventory.Product' });
            setLista(x);
            console.log(rta);
            setModal({ ...modal, "view": false, "name": "Agregar" });
        }).catch(err => {
            toast.error(err);
        });
    };



    const createProductRowForRawMaterialFromRequest = () => {

        instance.createProductRowForRawMaterialFromRequest(bean.IDRawMaterialRequest, bean.IDRawMaterial, bean.IDProductRef, properties.IDStore, bean.Quantity).then((rta: any) => {
            let x = [...lista];
            x.push({ DataBeanProperties: rta, DataBeanName: 'inventory.Product' });
            setLista(x);
            console.log(rta);
            setModalbysolicitud({ ...modalbysolicitud, "view": false, "name": "Agregar" });
        }).catch(err => {
            toast.error(err);
        });
    };



    const submitForm = () => {

        let key: any = Object.keys(data);
        // console.log({ [key[0]]: lista });
        // console.log(key[0].EditorObjectClassForName);


        if (setData) {
            setData({ [key[0]]: lista });
        }
    }
    const listaBotones = () => {
        const botones = [

            // { titulo: 'Editar', icono: 'ri-edit-2-line', visible: true, evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: true, evento: () => { setModal({ ...modal, "view": true }); deleteItem(); } },
            { titulo: 'Eliminar', icono: 'ri-edit-2-line', visible: true, evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    const deleteItem = () => {
        let temp = [];
        lista.forEach(element => {
            console.log(element);
            console.log(bean);

            if (element.DataBeanProperties != bean) {
                temp.push(element)
            }
        });
        setLista(temp)
        setModalC({ ...modalC, "view": false });
    }



    return (
        <div className="row">
            <div className="col-md-12">
                {/* <label>{data.BudgetList.Name}</label> */}
            </div>
            <div className="col-md-12">
                <Modal modal={modal} updateModal={setModal} eventModal={createProductRow}>
                    <>
                        <div className="row">
                            <div className="col-md-12">
                                <ProductionOrderEditor IDOrderProduction={0} returnData={(e) => { setBean({ ...bean, "IDProductionOrder": e.IDProductionOrder, "ProductionOrderDate": e.ProductionOrderDate }); console.log(e) }} />
                            </div>
                            {bean.IDProductionOrder &&
                                <div className="row">
                                    <div className="col-md-12">
                                        <label>Solo debe seleccionar un valor: Materia Prima o Producto*</label>
                                    </div>
                                    <div className="col-md-6">
                                        <label>Materia Prima por Orden de Producción</label>
                                        <SelectInputRawMaterialByProductionOrder render={bean.ProductName} idProductionOrder={bean.IDProductionOrder} productionOrderDate={bean.ProductionOrderDate} idSelector={bean.IDRawMaterial} onChange={(e) => { setBean({ ...bean, "IDRawMaterial": e.IDRawMaterial, "ProductName": e.ProductName }) }} label=" " returnType="Object" />
                                    </div>
                                    <div className="col-md-6">
                                        <SelectProductEditor label="Producto" value={bean.IDProductRef} onChange={(e) => { setBean({ ...bean, "IDProductRef": e.IDProduct }) }} />
                                    </div>

                                </div>
                            }

                            <div className="col-md-12">
                                <label>Cantidad</label>
                                <input type="number" name="Quantity" className="form-control" value={bean.Quantity} onChange={(e) => { setBean({ ...bean, "Quantity": Number(e.target.value) }) }} />
                            </div>

                        </div>

                    </>
                </Modal>
                <Modal modal={modalbysolicitud} updateModal={setModalbysolicitud} eventModal={createProductRowForRawMaterialFromRequest}>
                    <>
                        <div className="row">
                            <div className="col-md-12">
                                <label>No Solicitud de Material:</label>
                                <CatalogForRawMaterialeditor render={bean.ID} idSelector={bean.IDRawMaterialRequest} onChange={(e) => { setBean({ ...bean, "IDRawMaterialRequest": e.IDRawMaterialRequest, "ID": e.IDRawMaterialRequest }) }} label=" " returnType="Object" />
                            </div>
                            {bean.IDRawMaterialRequest &&
                                <>
                                    <div className="col-md-6">
                                        <label>Seleccionar Materia Prima:</label>
                                        <CatalogByRawMaterialRequestEditor render={bean.Name} idSelector={bean.IDRawMaterial} idRawMaterialRequest={bean.IDRawMaterialRequest} onChange={(e) => { setBean({ ...bean, "IDRawMaterial": e.IDRawMaterial, "Name": e.Name }) }} label=" " returnType="Object" />
                                    </div>
                                    <div className="col-md-6">
                                        <SelectProductEditor label="Producto" value={bean.IDProductRef} onChange={(e) => { setBean({ ...bean, "IDProductRef": e.IDProduct }) }} />
                                    </div>

                                </>
                            }
                            <div className="col-md-12">
                                <label>Cantidad</label>
                                <input type="number" name="Quantity" className="form-control" value={bean.Quantity} onChange={(e) => { setBean({ ...bean, "Quantity": Number(e.target.value) }) }} />
                            </div>
                        </div>

                    </>
                </Modal>

            </div>

            <div className="col-md-12">
                {/* <PrintJson json={lista} /> */}

                <div className="row">
                    <div className="col-md-12"><BasicTable head={head} body={lista} rowSet={setBean} iconButtons={iconButtonsItem} listButtons={listaBotones()} /></div>
                    <div className="col-md-12">
                        <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                            <strong>Eliminar item {bean.IDProduct}</strong>
                        </ModalConfirm>
                    </div>
                </div>
            </div>

            <div className="col-md-12">
                <BasicButton icon="ri-send-plane-2-line" clase="primary" eventClick={submitForm}>Enviar</BasicButton>
            </div>

            <div className="col-md-12">

            </div>
        </div>
    )
}